
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findTournamentBracketRound"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"group"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"round_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"league_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findTournamentBracketRound"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"Variable","name":{"kind":"Name","value":"group"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"round_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"round_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"league_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"league_id"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"footerImg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoImg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leagueName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bracket"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"header"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"match"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"team2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"team1Points"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"team2Points"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"players1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"players2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"result1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"result2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"points1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"points2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sumPoints1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sumPoints2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numHoles"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thru"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"player1Scores"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"player2Scores"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentTicker"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickerText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"maxPages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lang"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"associationName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zoom"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":652}};
    doc.loc.source = {"body":"query findTournamentBracketRound($group:Int!, $round_id:Int!, $league_id:Int!) {\n  findTournamentBracketRound(input:{ \n    group:$group, round_id:$round_id, league_id:$league_id}) {\n    footerImg\n    logoImg\n    leagueName\n    bracket {\n      header,\n      match { team1, team2, team1Points, team2Points, result },\n      matches {\n          players1, players2, result, result1, result2, points1, points2, sumPoints1, sumPoints2, numHoles, thru,\n          player1Scores,\n          player2Scores\n      }\n    }     \n    currentTicker{\n      tickerText\n      id\n    }\n    maxPages\n    showDuration\n    lang\n    associationName\n    lastUpdate\n    zoom\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["findTournamentBracketRound"] = oneQuery(doc, "findTournamentBracketRound");
        
